import React from "react";
import {
  View,
  SafeAreaView,
  ActivityIndicator,
  StyleSheet,
} from "react-native";
import { AppText } from "@/components/AppText";

const LoadingState = () => (
  <SafeAreaView style={styles.container}>
    <View style={styles.loadingState}>
      <ActivityIndicator size="large" color="#4F46E5" />
      <AppText style={styles.loadingText}>Loading offers...</AppText>
    </View>
  </SafeAreaView>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F8FAFC",
  },
  loadingState: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 64,
  },
  loadingText: {
    fontSize: 16,
    color: "#6B7280",
    marginTop: 16,
  },
});

export default LoadingState;
